import React, { useState } from 'react';
import { formatIndianNumber } from '../../lib/formatIndianNumber';
import {
  Avatar,
  Card,
  CardContent,
  Typography,
  Button,
  Chip,
  Grid,
  Box,
  Tabs,
  Tab,
  IconButton,
  Divider,
  Badge,
  Paper,
  Container
} from '@mui/material';
import {
  Favorite,
  Comment,
  Share,
  Flag,
  People,
  VideoLibrary,
  EmojiEvents,
  Email,
  Phone,
  Cake,
  AccountCircle,
  Settings,
  Edit
} from '@mui/icons-material';
import 'bootstrap/dist/css/bootstrap.min.css';

const UserFullDetails = () => {
  const [activeTab, setActiveTab] = useState(0);

  const userData = {
    username: 'mscreation',
    userId: '3416',
    fullName: 'Muhiuddin Inamdar',
    email: 'muhiuddininamdar88@gmail.com',
    mobile: '+91 9405579658',
    gender: 'MALE',
    dateOfBirth: '1971-10-14',
    accountType: 'PUBLIC',
    registerVia: 'Google',
    dateOfRegistration: 'Aug 29, 2025',
    totalChips: '30.0',
    followers: 0,
    following: 0,
    videos: 0,
    likes: 0,
    posts: 12,
    comments: 45,
    reports: 2,
    categories: [
      'Astrology', 'Beauty & Makeup', 'Comedy', 'Condolences', 'Devotional',
      'Education', 'Fashion', 'Friendship', 'Greetings', 'Health & Fitness',
      'Information', 'Jobs', 'Kitchen', 'Motivation', 'Movie Talent',
      'My Story', 'News', 'Govt & Politics', 'Romantic Skits', 'Success Stories',
      'Travel', 'Tutorials', 'Short Vlogs', 'Sports', 'Product/Brand Review'
    ]
  };

  const posts = [
    {
      id: 1,
      content: "Just completed an amazing project on sustainable architecture! 🏗️ #Architecture #Sustainability",
      likes: 24,
      comments: 8,
      shares: 3,
      timestamp: "2 hours ago",
      image: null
    },
    {
      id: 2,
      content: "Beautiful sunset from my terrace today. Nature never fails to amaze! 🌅",
      likes: 156,
      comments: 23,
      shares: 12,
      timestamp: "1 day ago",
      image: "/api/placeholder/400/300"
    },
    {
      id: 3,
      content: "Working on some new comedy content. Stay tuned for laughs! 😂 #Comedy #Entertainment",
      likes: 89,
      comments: 34,
      shares: 18,
      timestamp: "3 days ago",
      image: null
    }
  ];

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const StatsCard = ({ icon, count, label, color = 'primary' }) => (
    <Card sx={{ textAlign: 'center', height: '100%' }}>
      <CardContent>
        <Box sx={{ color: `${color}.main`, mb: 1 }}>
          {icon}
        </Box>
        <Typography variant="h6" component="div">
          {count}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
      </CardContent>
    </Card>
  );

  return (
    <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      {/* Header */}
      <div className="navbar navbar-expand-lg navbar-light bg-white shadow-sm">
        <Container>
          <div className="d-flex justify-content-between align-items-center w-100">
            <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', color: '#333' }}>
              User Profile
            </Typography>
            <Button
              variant="contained"
              startIcon={<Settings />}
              sx={{ borderRadius: 2 }}
            >
              Settings
            </Button>
          </div>
        </Container>
      </div>

      <Container sx={{ py: 4 }}>
        <div className="row g-4">
          
          {/* Left Sidebar - Profile Info */}
          <div className="col-lg-4">
            
            {/* Profile Card */}
            <Card sx={{ mb: 3, p: 3 }}>
              <CardContent sx={{ textAlign: 'center', p: 0 }}>
                <Box sx={{ position: 'relative', display: 'inline-block', mb: 2 }}>
                  <Avatar
                    sx={{
                      width: 120,
                      height: 120,
                      bgcolor: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      fontSize: '2rem',
                      fontWeight: 'bold'
                    }}
                  >
                    {userData.fullName.split(' ').map(n => n[0]).join('')}
                  </Avatar>
                  <IconButton
                    sx={{
                      position: 'absolute',
                      bottom: 0,
                      right: 0,
                      bgcolor: 'white',
                      boxShadow: 2,
                      '&:hover': { boxShadow: 4 }
                    }}
                    size="small"
                  >
                    <Edit fontSize="small" />
                  </IconButton>
                </Box>
                
                <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                  {userData.fullName}
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                  @{userData.username}
                </Typography>
                
                {/* Main Stats */}
                <div className="row g-2 mb-4">
                  <div className="col-3">
                    <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                      {userData.followers}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Followers
                    </Typography>
                  </div>
                  <div className="col-3">
                    <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                      {userData.following}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Following
                    </Typography>
                  </div>
                  <div className="col-3">
                    <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                      {userData.posts}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Posts
                    </Typography>
                  </div>
                  <div className="col-3">
                    <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                      {userData.likes}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Likes
                    </Typography>
                  </div>
                </div>

                {/* Additional Stats */}
                <div className="row g-2">
                  <div className="col-4">
                    <StatsCard
                      icon={<VideoLibrary />}
                      count={userData.videos}
                      label="Videos"
                      color="primary"
                    />
                  </div>
                  <div className="col-4">
                    <StatsCard
                      icon={<Comment />}
                      count={userData.comments}
                      label="Comments"
                      color="success"
                    />
                  </div>
                  <div className="col-4">
                    <StatsCard
                      icon={<Flag />}
                      count={userData.reports}
                      label="Reports"
                      color="error"
                    />
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Contact Info */}
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography variant="h6" component="h3" sx={{ mb: 2, fontWeight: 'bold' }}>
                  Contact Information
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Email sx={{ mr: 2, color: 'text.secondary' }} />
                  <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                    {userData.email}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Phone sx={{ mr: 2, color: 'text.secondary' }} />
                  <Typography variant="body2">
                    {userData.mobile}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Cake sx={{ mr: 2, color: 'text.secondary' }} />
                  <Typography variant="body2">
                    Born {userData.dateOfBirth}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <AccountCircle sx={{ mr: 2, color: 'text.secondary' }} />
                  <Typography variant="body2">
                    {userData.accountType} Account
                  </Typography>
                </Box>
              </CardContent>
            </Card>

            {/* Chips Balance */}
            <Card sx={{ 
              background: 'linear-gradient(135deg, #ffd700 0%, #ff8c00 100%)',
              color: 'white',
              mb: 3
            }}>
              <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="h6" component="h3" sx={{ fontWeight: 'bold', mb: 1 }}>
                    Chips Balance
                  </Typography>
                  <Typography variant="h4" component="div" sx={{ fontWeight: 'bold' }}>
                    {formatIndianNumber(userData.totalChips)}
                  </Typography>
                </Box>
                <EmojiEvents sx={{ fontSize: 48, opacity: 0.8 }} />
              </CardContent>
            </Card>
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            
            {/* Tabs */}
            <Card sx={{ mb: 3 }}>
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                variant="fullWidth"
                indicatorColor="primary"
                textColor="primary"
              >
                <Tab label={`Posts (${userData.posts})`} />
                <Tab label="Categories" />
                <Tab label="Activity" />
              </Tabs>
            </Card>

            {/* Tab Content */}
            {activeTab === 0 && (
              <div className="d-flex flex-column gap-4">
                {posts.map((post) => (
                  <Card key={post.id} sx={{ p: 3 }}>
                    <CardContent sx={{ p: 0 }}>
                      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                        <Avatar sx={{ bgcolor: 'primary.main' }}>
                          {userData.fullName.split(' ').map(n => n[0]).join('')}
                        </Avatar>
                        <Box sx={{ flexGrow: 1 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                            <Typography variant="subtitle1" component="h4" sx={{ fontWeight: 'bold' }}>
                              {userData.fullName}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              @{userData.username}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              •
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {post.timestamp}
                            </Typography>
                          </Box>
                          <Typography variant="body1" sx={{ mb: 2 }}>
                            {post.content}
                          </Typography>
                          {post.image && (
                            <Paper 
                              sx={{ 
                                height: 200, 
                                bgcolor: 'grey.200', 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center',
                                mb: 2
                              }}
                            >
                              <Typography color="text.secondary">
                                Image Placeholder
                              </Typography>
                            </Paper>
                          )}
                          <Divider sx={{ my: 2 }} />
                          <Box sx={{ display: 'flex', gap: 3 }}>
                            <Button
                              startIcon={<Favorite />}
                              size="small"
                              color="inherit"
                              sx={{ minWidth: 'auto' }}
                            >
                              {post.likes}
                            </Button>
                            <Button
                              startIcon={<Comment />}
                              size="small"
                              color="inherit"
                              sx={{ minWidth: 'auto' }}
                            >
                              {post.comments}
                            </Button>
                            <Button
                              startIcon={<Share />}
                              size="small"
                              color="inherit"
                              sx={{ minWidth: 'auto' }}
                            >
                              {post.shares}
                            </Button>
                          </Box>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                ))}
              </div>
            )}

            {activeTab === 1 && (
              <Card sx={{ p: 3 }}>
                <CardContent sx={{ p: 0 }}>
                  <Typography variant="h6" component="h3" sx={{ mb: 3, fontWeight: 'bold' }}>
                    Interest Categories
                  </Typography>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {userData.categories.map((category, index) => (
                      <Chip
                        key={index}
                        label={category}
                        variant="outlined"
                        color="primary"
                        sx={{ 
                          '&:hover': { 
                            backgroundColor: 'primary.light',
                            color: 'white'
                          }
                        }}
                      />
                    ))}
                  </Box>
                </CardContent>
              </Card>
            )}

            {activeTab === 2 && (
              <Card sx={{ p: 3 }}>
                <CardContent sx={{ p: 0 }}>
                  <Typography variant="h6" component="h3" sx={{ mb: 3, fontWeight: 'bold' }}>
                    Account Activity
                  </Typography>
                  <div className="d-flex flex-column gap-3">
                    <Paper sx={{ p: 2, bgcolor: 'grey.50' }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body1" color="text.secondary">
                          Registration Date
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                          {userData.dateOfRegistration}
                        </Typography>
                      </Box>
                    </Paper>
                    <Paper sx={{ p: 2, bgcolor: 'grey.50' }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body1" color="text.secondary">
                          Registered Via
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                          {userData.registerVia}
                        </Typography>
                      </Box>
                    </Paper>
                    <Paper sx={{ p: 2, bgcolor: 'grey.50' }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body1" color="text.secondary">
                          User ID
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                          #{userData.userId}
                        </Typography>
                      </Box>
                    </Paper>
                    <Paper sx={{ p: 2, bgcolor: 'grey.50' }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body1" color="text.secondary">
                          Account Status
                        </Typography>
                        <Chip
                          label="Active"
                          color="success"
                          size="small"
                        />
                      </Box>
                    </Paper>
                  </div>
                </CardContent>
              </Card>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default UserFullDetails;